import styled, { css, keyframes } from 'styled-components';

const Skeleton_animation = keyframes`
    0% {
        transform: translateX(-150%);
    }
    50% {
        transform: translateX(-60%);
    }
    100% {
        transform: translate(150%);
    }
`;

export const SkeletonElement = styled.div`
  width: 70px;
  height: 70px;
  display: block;
  margin: 5px;
  background-color: ${props => (props.theme.theme === 'dark' ? `rgba(0, 0, 0, 0.3)` : `rgba(0, 0, 0, 0.11)`)};

  position: relative;
  overflow: hidden;

  .shimmer-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    animation: ${Skeleton_animation} 1.6s linear 0.5s infinite;
  }

  .shimmer {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    content: '';
    position: absolute;
    transform: translateX(-100%);
    background: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.04), transparent);
  }

  ${props =>
    props.type === 'box' &&
    css`
      width: 100%;
      height: 220px;
    `}

  ${props =>
    props.type === 'text' &&
    css`
      width: 100%;
      height: 10px;
    `}

  ${props =>
    props.type === 'circle' &&
    css`
      width: 30px;
      height: 30px;
      border-radius: 50%;
    `}

  ${props =>
    props.width &&
    css`
      width: ${props.width};
    `};
  ${props =>
    props.height &&
    css`
      height: ${props.height};
    `}
  ${props =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const ScheduleSkeletonContanier = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 32px;

  border-bottom: 1px solid ${props => props.theme.line};
`;
